import { useEffect } from 'react';
import {
  buildClientFaviconCandidateUrls,
  preloadFirstImageUrl,
  resolveFaviconLinkType,
} from '../utils/clientLogoUrl';
import { themeRegistry } from '../utils/themeRegistry';
import { getRuntimeEnv } from '../utils/runtimeEnv';

function applyFaviconHref(url: string): void {
  const faviconLink = document.getElementById('favicon') as HTMLLinkElement | null;
  if (!faviconLink) {
    return;
  }
  faviconLink.href = url;
  const type = resolveFaviconLinkType(url);
  if (type) {
    faviconLink.type = type;
  } else {
    faviconLink.removeAttribute('type');
  }
}

/**
 * Loads tab favicon and document title for the configured client.
 * CloudFront favicon.svg when REACT_APP_CLOUDFRONT_S3_URL is set (all clients).
 */
export const useFavicon = () => {
  useEffect(() => {
    const cloudFrontUrl = getRuntimeEnv('REACT_APP_CLOUDFRONT_S3_URL');
    const clientName = getRuntimeEnv('REACT_APP_CLIENT_NAME');

    if (clientName) {
      const theme = themeRegistry.getTheme(clientName);
      if (theme?.name) {
        document.title = theme.name;
      } else {
        document.title = 'Movil SGR';
      }
    } else {
      document.title = 'Movil SGR';
    }

    const candidates = buildClientFaviconCandidateUrls(
      clientName,
      cloudFrontUrl,
    );

    if (candidates.length === 0) {
      return;
    }

    preloadFirstImageUrl(candidates).then((faviconUrl) => {
      if (faviconUrl) {
        applyFaviconHref(faviconUrl);
      }
    });
  }, []);
};
